export type OrderSettlementCommandReadModelRefresh = () => Promise<unknown> | unknown;

export interface OrderSettlementCommandReadModelRefreshers {
  order: OrderSettlementCommandReadModelRefresh;
  transports: OrderSettlementCommandReadModelRefresh;
  readiness: OrderSettlementCommandReadModelRefresh;
  marginHistory: OrderSettlementCommandReadModelRefresh;
  marginExplanation: OrderSettlementCommandReadModelRefresh;
  settlementLedger: OrderSettlementCommandReadModelRefresh;
}

/**
 * One source of refetch truth after a one-shot settlement command. Even an
 * OPERATIONS response is allowed to alter a later ADMIN read model, so callers
 * always refetch the whole canonical set and let permissions redact it.
 */
export async function refreshOrderSettlementCommandReadModels(
  refreshers: OrderSettlementCommandReadModelRefreshers,
): Promise<void> {
  await Promise.all([
    refreshers.order(),
    refreshers.transports(),
    refreshers.readiness(),
    refreshers.marginHistory(),
    refreshers.marginExplanation(),
    refreshers.settlementLedger(),
  ]);
}

export async function runOrderSettlementCommandMutation<T>(
  mutate: () => Promise<T>,
  refresh: OrderSettlementCommandReadModelRefresh,
): Promise<T> {
  const result = await mutate();
  await refresh();
  return result;
}
